import React, { Component } from 'react';
// Externals
import compose from 'recompose/compose';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import highchartsMore from "highcharts/highcharts-more.js";
import xRange from "highcharts/modules/xrange.js";
import { withRouter } from 'react-router-dom';
import { api_host, api_auth } from '../../../../../common/globals/constants';

import PortletContent from 'components/PortletContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import moment from 'moment'
import 'moment/locale/es'  
import { TableCell, Table } from '@material-ui/core';
import {COLORS} from '../../../../../utils/colors'
moment.locale('es')

highchartsMore(Highcharts);
xRange(Highcharts);
Highcharts.setOptions({
    lang: {
        months: [
            'Enero', 'Febrero', 'Marzo', 'Abril',
            'Mayo', 'Junio', 'Julio', 'Agosto',
            'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ],
        weekdays: [
            'Domingo', 'Lunes', 'Martes', 'Miércoles',
            'Jueves', 'Viernes', 'Sábado'
        ]
    }
});

class AvailabilityConsolidated extends Component {

    constructor(props) {
        super(props);

        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            objId: this.props.objetivo_id,
            objName: this.props.objetivo_name,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            hoverData: null,
            lastEvent: [],
            //statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            chartOptionsBase: this._chartOptionsBase,
            chartOptionsStackedBarConsolidated: this._chartOptionsBase,
            chartOptionsStackedBarNode: this._chartOptionsBase,
            //isRefresh: this.props.params.isRefresh,
            //date: this.props.params.date,
            dateMoment:((moment().locale('es')).format("DD/MM/YYYY, HH:mm:ss a")),
            modalOpen: false,
            modalClose : true, 
            point: [],
            monitores: [],
            dataEstadoGeneral: null,
        }
    }
    _chartOptionsBase = {
        chart: {
            type: 'xrange'
        },
        title: {
            text: null
        },
        xAxis: {
            type: 'datetime',
            gridLineWidth: 0,
        },
        yAxis: {
            title: {
                text: ''
            },
            gridLineWidth: 0,
            reversed: true,
            labels: {
                useHTML:true,//set to true
                style:{
                    whiteSpace:'normal'//set to normal
                },
                step: 1,
                formatter: function () {//use formatter
                    var objNameLabel = this.value
                    return '<div align="initial" style="word-wrap: break-word;word-break: break-all;width:200px">' + objNameLabel + '</div>';
                }
            },
        },
        plotOptions: {
            series: {
                borderRadius: 0,
                borderColor: 'transparent',
                pointWidth: 10,
                turboThreshold: 0,
                grouping: false
            }
        },
        credits: {
            enabled: false
        },
        tooltip: {
            xDateFormat: '%A, %b %e, %Y %H:%M:%S',
            enabled: true,
            animation: false,
            pointFormat: '',
            followPointer: true,
            useHTML: true,
            className: 'general-status',
            padding: 1,
        }
    }

    setHoverDataBar = (e) => {      
        const { x, x2, y, series, yCategory } = e.target 
        // The chart is not updated because `chartOptions` has not changed.
        let point = []
        point['x'] = x
        point['x2'] = x2
        point['y'] = series.chart.yAxis[0].categories[y]
        let step = series.userOptions.name
        //this.props.params.onInfo(point, step)
    }

    setClickDataBar = (e) => {         
        const { x, x2, y, series, yCategory } = e.point     
        // The chart is not updated because `chartOptions` has not changed.
        let point = []
        point['x'] = x
        point['x2'] = x2
        point['y'] = series.chart.yAxis[0].categories[y]
        let step = series.userOptions.name
        this.setState({
            point: point,
            modalOpen: true,
            modalClose : false
        })
        //this.props.params.onInfoModal(point, step)
    }

    setCloseModal=()=>{
        this.setState({
            modalOpen : false,
            modalClose : true
        })
    }

    static getDerivedStateFromProps(props, state) {
        if (props.period !== state.time) {
            return {
                chartOptionsStackedBarConsolidated: state.chartOptionsBase,
                chartOptionsStackedBarNode: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.objetivo_id,
                time: props.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                //statePeriod: props.params.statePeriod,
                //isStatePeriod: props.params.isStatePeriod
            }
        }
        return null;
    }


    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        if ((prevProps.period !== this.state.time) || (prevProps.statePeriod?.startDate !== this.props?.statePeriod?.startDate || prevProps.statePeriod?.endDate !== this.props?.statePeriod?.endDate)) {
            this.getDataFromAPI();
        }
        if (prevProps.isSpecial !== this.props.isSpecial && this.state.dataEstadoGeneral) {
            this.processData(
                this.state.dataEstadoGeneral,
                this.props.period,
                null,
                null,
                this.props.isSpecial
            )
        }
    }
    componentWillUnmount() {

    }

    getDataFromAPI = (objectiveId) => {
        const { objetivo_id, period, statePeriod } = this.props
        let node = 0
        
        let fecha_inicio = statePeriod ? moment(statePeriod.startDate).format('YYYY-MM-DD') : null
        let fecha_termino = statePeriod ? moment(statePeriod.endDate).format('YYYY-MM-DD') : null
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        if (period === 'c') {
            fetch(api_host+`/reporte/online/indicadores/getDetalleDisponibilidadParcialObjetivoDowntimeCustom/?user=${user}&key=${api_auth}&horarioId=0&t=c&objetivoId=${objetivo_id}&fechaInicio=${fecha_inicio}&fechaTermino=${fecha_termino}&token=${token}&nodoId=${node}`)
                .then(response => response.json())
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);             
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson,
                                period,
                                fecha_inicio,
                                fecha_termino)
                            /*if (this.state.lastEvent !== []) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }*/
                            this.setState({dataEstadoGeneral: myJson})
                        } catch (error) {
                            console.log(error)
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }
                });
        } else {
            if (period.length === 0){
                this.setState({
                    dataError: true,
                    data: null,
                    isLoading: false
                });

            }else{
                fetch(api_host+`/reporte/online/indicadores/getDetalleDisponibilidadParcialObjetivoDowntime/?user=${user}&key=${api_auth}&objetivoId=${objetivo_id}&horarioId=0&t=${period}&token=${token}&nodoId=${node}`)
                
                    .then(response => response.json())
                    .then(myJson => {
                        // Se define el state de acuerdo a la petición y respuesta de la promesa 
                        if (myJson.status == 1 || myJson.status == 5) {
                            localStorage.setItem('isAuthenticated', false);             
                        } else {
                            //Procesa la Data Recibida
                            try {
                                this.processData(myJson,
                                    period,
                                    fecha_inicio,
                                    fecha_termino)
                                /*if (this.state.lastEvent !== []) {
                                    this.props.params.onFirstInfo(this.state.lastEvent)
                                }*/
                                this.setState({dataEstadoGeneral: myJson})
                            } catch (error) {  
                                this.setState({
                                    dataError: true,
                                    data: null,
                                    isLoading: false
                                });
                            }
                        }

                    });
            }

        }
    }

    // Helper para procesar la data de la petición a la API

    processData = (externalDataConsolidated,
        period,
        fecha_inicio,
        fecha_termino,
        isSpecial = false) => {
        const validateIsSpecial = isSpecial || this.props.isSpecial
        //const { Nodo, Objetivo_Nombre, Monitores } = externalData.Objetivo
        const { estado } = externalDataConsolidated.Objetivo.Nodo[0]
        const { objName } = this.state
        let lastEventDict = []
        let arrayChartDataStackedBar = [] 
 
        if (period === 'h') {
            lastEventDict['namePeriod'] = 'Rango: última hora'
        } else if (period === 'd') {
            lastEventDict['namePeriod'] = 'Rango: último día'
        } else if (period === 'w') {
            lastEventDict['namePeriod'] = 'Rango: última semana'
        } else if (period === 'c') {
            lastEventDict['namePeriod'] = 'Rango: ' + fecha_inicio + ' a ' + fecha_termino
        }
    
        let dictDataStackedBarUptime = {}
        dictDataStackedBarUptime['name'] = 'Uptime'
        dictDataStackedBarUptime['pointWidth'] = 40
        let arrayDataUptime = []

        let dictDataStackedBarDowntime = {}
        dictDataStackedBarDowntime['name'] = 'Downtime'
        dictDataStackedBarDowntime['pointWidth'] = 40
        let arrayDataDowntime = []

        let dictDataStackedBarNoMon = {}
        dictDataStackedBarNoMon['name'] = 'No Monitoreo'
        dictDataStackedBarNoMon['pointWidth'] = 40
        let arrayDataNoMon = []

        let dictDataStackedBarPartial = {}
        dictDataStackedBarPartial['name'] = 'Downtime Parcial'
        dictDataStackedBarPartial['pointWidth'] = 40
        let arrayDataPartial = []

        let dictDataStackedBarEvent = {}
        dictDataStackedBarEvent['name'] = 'Mantenimiento'
        dictDataStackedBarEvent['pointWidth'] = 40
        let arrayDataEvent = []

        let dictDataStackedBarMarcadoAtentus = {}
        dictDataStackedBarMarcadoAtentus['name'] = 'Marcado atentus'
        dictDataStackedBarMarcadoAtentus['pointWidth'] = 40
        let arrayDataMarcadoAtentus = []

        Object.keys(estado).forEach((key) => {
            let dictDataStackedBar = {}

            let dateJson = new Date(estado[key]['fecha_desde'].substring(0, 19))
            let year = dateJson.getFullYear()
            let month = dateJson.getMonth()
            let day = dateJson.getDate()
            let hours = dateJson.getHours()
            let minutes = dateJson.getMinutes()
            let seconds = dateJson.getSeconds()

            let dateJsonEnd = (new Date(estado[key]['fecha_hasta'].substring(0, 19)))
            let yearEnd = dateJsonEnd.getFullYear()
            let monthEnd = dateJsonEnd.getMonth()
            let dayEnd = dateJsonEnd.getDate()
            let hoursEnd = dateJsonEnd.getHours()
            let minutesEnd = dateJsonEnd.getMinutes()
            let secondsEnd = dateJsonEnd.getSeconds()

            dictDataStackedBar['x'] = Date.UTC(year,(month),day,hours,minutes,seconds)
            dictDataStackedBar['x2'] = Date.UTC(yearEnd,(monthEnd),dayEnd,hoursEnd,minutesEnd,secondsEnd)
            dictDataStackedBar['y'] = 0
            if (validateIsSpecial) {
                if (estado[key]['nombre'] == 'uptime') {
                    if (arrayDataUptime.length) {
                        let lastUptime = arrayDataUptime[arrayDataUptime.length - 1]
                        if (lastUptime['x2'] === dictDataStackedBar['x']) {
                            lastUptime['x2'] = dictDataStackedBar['x2']
                            arrayDataUptime[arrayDataUptime.length - 1] = lastUptime
                        } else {
                            dictDataStackedBar['color'] = COLORS.UPTIME
                            arrayDataUptime.push(dictDataStackedBar)
                        }
                    } else {
                        dictDataStackedBar['color'] = COLORS.UPTIME
                        arrayDataUptime.push(dictDataStackedBar)
                    }
                } else if (estado[key]['nombre'] == 'downtime') {
                    dictDataStackedBar['color'] = COLORS.DOWNTIME
                    arrayDataDowntime.push(dictDataStackedBar)
                } else if (estado[key]['nombre'] == 'no monitoreo') {
                    dictDataStackedBar['color'] = COLORS.NO_MONITOREO
                    arrayDataNoMon.push(dictDataStackedBar)
                } else if (estado[key]['nombre'] == 'downtime parcial') {
                    if (Number(key) > 0 && estado[Number(key) - 1].nombre == 'uptime') {
                        let lastUptime = arrayDataUptime.pop()
                        lastUptime['x2'] = dictDataStackedBar['x2']
                        arrayDataUptime.push(lastUptime)
                    } else {
                        dictDataStackedBar['color'] = COLORS.UPTIME
                        arrayDataUptime.push(dictDataStackedBar)
                    }
                } else if (estado[key]['nombre'] == 'evento cliente') {
                    dictDataStackedBar['color'] = COLORS.EVENTO_CLIENTE
                    arrayDataEvent.push(dictDataStackedBar)
                } else if (estado[key]['nombre'] == 'marcado atentus') {
                    dictDataStackedBar['color'] = COLORS.MARCADO_ATENTUS
                    arrayDataMarcadoAtentus.push(dictDataStackedBar)
                }
            } else {
                if (estado[key]['nombre'] == 'uptime') {
                    dictDataStackedBar['color'] = COLORS.UPTIME
                    arrayDataUptime.push(dictDataStackedBar)
                } else if (estado[key]['nombre'] == 'downtime') {
                    dictDataStackedBar['color'] = COLORS.DOWNTIME
                    arrayDataDowntime.push(dictDataStackedBar)
                } else if (estado[key]['nombre'] == 'no monitoreo') {
                    dictDataStackedBar['color'] = COLORS.NO_MONITOREO
                    arrayDataNoMon.push(dictDataStackedBar)
                } else if (estado[key]['nombre'] == 'downtime parcial') {
                    dictDataStackedBar['color'] = COLORS.DOWNTIME_PARCIAL
                    arrayDataPartial.push(dictDataStackedBar)
                } else if (estado[key]['nombre'] == 'evento cliente') {
                    dictDataStackedBar['color'] = COLORS.EVENTO_CLIENTE
                    arrayDataEvent.push(dictDataStackedBar)
                } else if (estado[key]['nombre'] == 'marcado atentus') {
                    dictDataStackedBar['color'] = COLORS.MARCADO_ATENTUS
                    arrayDataMarcadoAtentus.push(dictDataStackedBar)
                }
            }
        })
       
        dictDataStackedBarUptime['data'] = arrayDataUptime
        dictDataStackedBarDowntime['data'] = arrayDataDowntime
        dictDataStackedBarNoMon['data'] = arrayDataNoMon
        dictDataStackedBarPartial['data'] = arrayDataPartial
        dictDataStackedBarEvent['data'] = arrayDataEvent
        dictDataStackedBarMarcadoAtentus['data'] = arrayDataMarcadoAtentus

        let heightNodeChart = 200
        /*if (Nodo.length < 3) {
            heightNodeChart = 150
        } else if(Nodo.length > 5) {
            heightNodeChart = 400
        }*/
        this.setState({
            chartOptionsStackedBarConsolidated: {
                pane: {
                    size: '150%',
                },
                yAxis: { 
                    categories: [objName]},                
        
                series: [dictDataStackedBarUptime, dictDataStackedBarDowntime, dictDataStackedBarNoMon, dictDataStackedBarPartial, dictDataStackedBarEvent, dictDataStackedBarMarcadoAtentus],
                plotOptions: {
                    series: {
                        datalabels: false,
                        cursor: 'pointer',
                        point: {
                            events: {
                                //mouseOver: this.setHoverDataBar.bind(this),
                                //click: this.setClickDataBar.bind(this)
                            }
                        }
                    }
                },
                legend: {
                    enabled: false
                },
                xAxis: {
                    labels: {
                        enabled: false
                    },
                    visible: false

                },
                chart: {
                    height: 35,
                    //width: 500
                },
                
            },
            
            dataError: false,
            isLoading: false,
            lastEvent: lastEventDict,
            time: period,
            //monitores: Monitores
        });

    }
    render() {
        const { classes, className, location } = this.props;
        const { dataError, chartOptionsStackedBarConsolidated, chartOptionsStackedBarNode, isLoading, modalOpen, modalClose, currentObjectiveId, point, monitores, objName} = this.state;
        const style = isLoading ? { display: 'none' } : {border: 'none', maxWidth:'80vw', minWidth:'80vw', padding:'0px'};
        const styleHidden = isLoading ? {} : { display: 'none' };
        var objNameLabel = objName
        if (!dataError) {
            return (<FormattedChart chartOptionsStackedBarConsolidated={chartOptionsStackedBarConsolidated} 
                                    chartOptionsStackedBarNode={chartOptionsStackedBarNode} style={style} 
                                    styleHidden={styleHidden} modalOpen={modalOpen} modalClose={this.setCloseModal} 
                                    classes={classes} objective={currentObjectiveId}
                                    point={point}
                                    monitores={monitores}/>
                                    )
        } else if (dataError) {
            return (<Table style={{maxWidth:'80vw', minWidth:'80vw', padding:'0px'}}>
                        <TableCell
                            style={{
                            border: 'none',
                            width:'200px',    
                            textAlign:'initial', 
                            fontSize:'11px', 
                            fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif', 
                            color:'#666666',
                            marginLeft:'0',
                            //paddingRight:'30px',
                            paddingTop:'15px',
                            paddingBottom: '0px',
                            paddingLeft: 10
                            }} >
                                {objNameLabel}
                        </TableCell>
                        <TableCell
                            style={{
                                border: 'none',
                            textAlign:'center', 
                            fontSize:'11px', 
                            fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif', 
                            color:'#666666',
                            paddingTop: '15px',
                            paddingLeft: 10,
                            marginLeft:'0'}}>
                                No hay datos
                        </TableCell>
                    </Table>)
        }
        else return (<p>Error!</p>)

    }
}

function FormattedChart(props) {
 
    return (
        <div style={{maxHeight:'20px'}}>
            <div style={props.styleHidden}>
                <PortletContent>
                    <Grid style={{fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif', height: '85px', fontSize: '14px', color: '#666666', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '24px', padding: "0.5rem" }} >
                            <CircularProgress variant="indeterminate" size={24} thickness={4} />
                        </Grid>
                        <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '24px', padding: "0.5rem" }} >
                                Cargando disponibilidad
                        </Grid>
                    </Grid>
                </PortletContent>
            </div>
            <div style={props.style}>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={props.chartOptionsStackedBarConsolidated} />
            </div>
            
        </div>
    )
}

export default compose(withRouter, withStyles(styles))(AvailabilityConsolidated);